export default __webpack_public_path__ + "static/media/archywavelogo.1742eb04.png";